<div class="container-fluid">
    <div class="row g-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
  
    <form [formGroup]="gradeCardForm">
<div>
    <button mat-raised-button color="primary" (click)="CourseWiseDisplay()">CourseSem wise Grade Cards</button>&nbsp;&nbsp;
    <button mat-raised-button color="primary" (click)="registerNoWiseDisplay()">Register number Grade Cards</button>
</div>
<div>
    <div class="form-two-cols">
        <!-- Select Month -->
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Year</mat-label>
          <mat-select formControlName="selectedMonth">
            <mat-option *ngFor="let month of months" [value]="month.months_name">
              {{ month.months_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Select Year</mat-label>
          <mat-select formControlName="selectedYear">
            <mat-option *ngFor="let year of yearss" [value]="year.year_name">
              {{ year.year_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div class="form-two-cols" >
        <!-- Select Course -->
        <mat-form-field appearance="fill">
          <mat-label>Select Course</mat-label>
          <mat-select formControlName="selectCourse">
            <mat-option *ngFor="let course of courseNames" [value]="course.id">{{ course.name }}-{{course.crs_code}}</mat-option>
          </mat-select>
        </mat-form-field>

         <mat-form-field *ngIf="isregNumWiseGradeCard" appearance="fill">
              <mat-label>Enter Register No</mat-label>
              <input matInput placeholder="ENTER REG NO" formControlName="selectedReg">
            </mat-form-field>
          
        
      </div>
        <!-- <mat-form-field appearance="fill">
            <mat-label>Select Semester</mat-label>
            <mat-select formControlName="selectSem">
              <mat-option *ngFor="let sem of semesterNumbers" [value]="sem.id">{{ sem.name }}</mat-option>
            </mat-select>
          </mat-form-field> -->
      </div>
      
   
     
<div class="mb-4">
    <button mat-raised-button color="primary" (click)="Display()">Display Grade Cards</button>
    <button mat-raised-button color="accent" class="ml-2" type="button" (click)="reloadPage()">Clear</button>
    <button *ngIf="!isregNumWiseGradeCard" mat-raised-button color="warn" class="ml-2" type="button" (click)="startBatchDownload()">Batch Download PDF(Page wise(5))</button>
    <button *ngIf="isregNumWiseGradeCard" mat-raised-button color="warn" class="ml-2" type="button" (click)="DownloadPdfJSPDF()">DownLoadPdf</button>
    <div *ngIf="isProcessing" class="mt-4">
  
  <mat-progress-bar
    mode="determinate"
    [value]="progressPercent"
    color="primary"
  ></mat-progress-bar>
  <div class="d-flex justify-content-between align-items-center mt-2">
    <span>{{ progressPercent }}% completed</span>
    <span>{{ estimatedTime }}</span>
    <button mat-stroked-button color="warn" (click)="cancelDownload()">Cancel</button>
  </div>
</div>

  </div>
     
      </form>
   <div *ngIf="!isregNumWiseGradeCard">    
      <div class="form-group button-container">
      
        
        <div *ngIf="isLoading" class="modal show d-block" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Loading</h5>
              </div>
              <div class="modal-body">
                <p>Please wait...</p>
              </div>
            </div>
          </div>
        </div>
      </div>


  <div class="pagination-controls mt-3 text-center" *ngIf="getExamResultData.length > pageSize">
  <button mat-stroked-button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
    Previous
  </button>

  <button
    mat-stroked-button
    *ngFor="let page of totalPages"
    [color]="page === currentPage ? 'primary' : ''"
    (click)="goToPage(page)"
    style="margin: 0 4px;"
  >
    {{ page }}
  </button>

  <button mat-stroked-button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages.length">
    Next
  </button>
</div>
   
   

  <div *ngFor="let semester of paginatedResults; let j = index">
  <div class="a4-sheet">
    <div class="multiple" [id]="'contentToConvertProvisional' + j">
      <div [id]="'contentToConvertProvisional' + j">
        <div class="marks-card">
      <div class="header-multi">
        <div class="sno">
          <span class="static-field">Sl.No. &nbsp;: &nbsp;{{semester.gradeCardNumber}}</span>
        </div>
         <div class="center multiple">
            <div class="container static-field">
              <img src="assets/images/img/KarntakaLogo.png" alt="Logo" style="height: 40px; margin: 0 10px;"><br />

            </div>
            <h3 class="static-field">ಕರ್ನಾಟಕ ಸರ್ಕಾರ</h3>
            <h3 class="static-field">Government of Karnataka</h3>
            <h3 class="static-field">ತಾಂತ್ರಿಕ ಶಿಕ್ಷಣ ಇಲಾಖೆ, ಬೆಂಗಳೂರು.</h3>
            <h3 class="static-field">Department Of Technical Education, Bangalore.</h3>
            <h3 class="static-field">ತಾಂತ್ರಿಕ ಪರೀಕ್ಷಾ ಮಂಡಳಿ</h3>
            <h3 class="static-field">BOARD OF TECHNICAL EXAMINATIONS.</h3>
            <h3>
              <span class="static-field">B.V.V.S.POLYTECHNIC(AUTONOMOUS), BAGALKOT.</span>
              <!-- <span>:{{ semester.Exam_month }}-{{ semester.Exam_year }}</span> -->
            </h3>
            <h3>
            <span class="static-field">GRADE CARD</span>
            </h3>
          </div>
        <div class="right static-field">
          <img  [src]="semester.safePhotoUrl" style="width:180px;height:180px;" alt="Student Photo" />
        </div>
      </div>
      <div class="header-multiple">
        <div class="sno">
          <span class="static-field">Sl.No. &nbsp;: &nbsp;{{semester.gradeCardNumber}}</span>
        </div>
        <div class="center">
          <h3>
            <span style="padding-right: 349px; font-size: 24px;">{{ semester.Exam_month }}-{{ semester.Exam_year }}</span>
          </h3>
        </div>
      </div>


<div class="info-grid">
  <div class="info-row">
    <span class="label static-field">PROGRAMME</span>
    <span class="colon static-field">:</span>
    <span class="value-courseName">{{ semester.courseName }}</span>
  </div>

  <div class="info-row">
    <span class="label static-field">NAME OF THE CANDIDATE</span>
    <span class="colon static-field">:</span>
    <span class="value-studentName">{{ semester.studentName }}</span>
  </div>

  <div class="info-row">
    <span class="label static-field">FATHER'S NAME</span>
    <span class="colon static-field">:</span>
    <span class="value-fatherName">{{ semester.father_name }}</span>
  </div>

  <div class="info-row">
    <span class="label static-field">MOTHER'S NAME</span>
    <span class="colon static-field">:</span>
    <span class="value-motherName">{{ semester.studentMotherName }}</span>
  </div>

  <!-- ✅ Combined row at the bottom -->
  <div class="info-bottom-row">
    <div class="left-part">
      <span class="label static-field">DATE OF RESULT</span>
      <span class="colon static-field">:</span>
      <span class="value-dateOfResult">{{ semester.dateOfResult | date:'dd/MM/yyyy' }}</span>
    </div>
    <div class="right-part">
      <!-- <span class="label-register static-field">REGISTER NO</span> -->
      <span class="colon static-field"></span>
      <span class="label-register">{{ semester.registerNo }}</span>
    </div>
  </div>
</div>

      <div class="table-container-multi">
        <table class="course-table">
          <thead>
            <tr>
              <th rowspan="2" class="static-field col-sem">SEM</th>
              <th rowspan="2" class="static-field col-sino">Sl. No</th>
              <th class="static-field col-subject" rowspan="2">Course Code & Course Title</th>
              <th colspan="2" class="static-field col-credits">Credits</th>
              <th rowspan="2" class="static-field col-points">Grade Points</th>
              <th rowspan="2" class="static-field col-grade">Letter Grade </th>
            </tr>
            <tr>
              <th class="static-field">Applied</th>
              <th class="static-field">Earned</th>
            </tr>
          </thead>
          <tbody *ngIf="resetSeparatorFlag()">


            <ng-container
              *ngIf="semester.semWiseCumilativeResult?.length <= semester.maxSemesterNumber; else normalDisplay">
              <ng-container *ngFor="let subject of semester.subjectDetailsList; let i = index">
                <!-- Subject row -->
                <tr>
                  <td class="col-sem">{{ subject.sem }}</td>
                  <td class="col-sino">{{ subject.SINO }}</td>
                  <td class="col-subject">{{ subject.subject_code }} {{ subject.subject_name }}</td>
                  <td class="col-credit-applied">{{ subject.totalCredits }}</td>
                  <td class="col-credit-earned">{{ subject.earnedCredit }}</td>
                  <td class="col-points">{{ subject.gradePoints }}</td>
                  <td class="col-grade">{{ subject.gradeAwarded }}</td>
                </tr>
                <!-- Dashed separator: if it's the last subject of a semester -->
                <tr *ngIf="shouldShowSeparator(subject.sem,semester?.subjectDetailsList, i)">
                  <td></td>
                  <td></td>
                  <td class="dashed-separator">
                    <hr />
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </ng-container>

              <!-- Add empty rows if less than 15 -->
              <ng-container
                *ngFor="let empty of getArray(semester.subjectDetailsList); let i = index; trackBy: trackByIndex">
                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </ng-container>
            </ng-container>

            <!-- No data available fallback -->
            <ng-template #normalDisplay>
              <ng-container *ngFor="let subject of semester.subjectDetailsList; let i = index">
                <tr *ngIf="shouldShowSeparator(subject.sem,semester?.subjectDetailsList, i)">
                  <td></td>
                  <td></td>
                  <td class="dashed-separator">
                    <hr />
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <!-- Subject row -->
                <tr>
                  <td>{{ subject.sem }}</td>
                  <td>{{ subject.SINO }}</td>
                  <td style="text-align:left !important">
                    {{ subject.subject_code }} &nbsp;&nbsp; {{ subject.subject_name }}
                  </td>
                  <td>{{ subject.totalCredits }}</td>
                  <td>{{ subject.earnedCredit !== null ? subject.earnedCredit : '-' }}</td>
                  <td>{{ subject.gradePoints !== null ? subject.gradePoints : '-' }}</td>
                  <td>{{ subject.gradeAwarded || '-' }}</td>
                </tr>
              </ng-container>
              <ng-container
                *ngFor="let empty of getArray(semester.subjectDetailsList); let i = index; trackBy: trackByIndex">
                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </ng-container>

            </ng-template>
          </tbody>

        </table>
      </div>

      <div class="table-container-cgpa-multi">
        <table class="semester-table">
          <thead>
            <tr>
              <th class="static-field">Semester</th>
              <th class="static-field">I</th>
              <th class="static-field">II</th>
              <th class="static-field">III</th>
              <th class="static-field">IV</th>
              <th class="static-field">V</th>
              <th class="static-field">VI</th>
              <th class="static-field">Cumulative</th>
              <th class="static-field">UpTo This Exam</th>
            </tr>
          </thead>
          <tbody>

            <tr>
              <td class="static-field">Credits Applied</td>

              <td><span> {{semester?.semWiseCumilativeResult[0]?.TotalCreditsForSem}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[1]?.TotalCreditsForSem}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[2]?.TotalCreditsForSem}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[3]?.TotalCreditsForSem}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[4]?.TotalCreditsForSem}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[5]?.TotalCreditsForSem}}</span></td>

              <td class="static-field">Credits Earned</td>
              <td>{{ semester?.cumulative_credits_earned }}</td>
            </tr>

            <tr>
              <td class="static-field">Credits Earned</td>
              <td><span> {{semester?.semWiseCumilativeResult[0]?.sem_credits_earned}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[1]?.sem_credits_earned}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[2]?.sem_credits_earned}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[3]?.sem_credits_earned}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[4]?.sem_credits_earned}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[5]?.sem_credits_earned}}</span></td>
              <td class="static-field">CGPA</td>
              <td>{{ semester.cgpa }}</td>
            </tr>
            <tr>
              <td class="static-field">Σ(Ci X Gi)Earned</td>
              <td><span> {{semester?.semWiseCumilativeResult[0]?.sem_weighted_average}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[1]?.sem_weighted_average}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[2]?.sem_weighted_average}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[3]?.sem_weighted_average}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[4]?.sem_weighted_average}}</span></td>
              <td><span> {{semester?.semWiseCumilativeResult[5]?.sem_weighted_average}}</span></td>
              <td class="static-field">%Conversion</td>
              <td>{{ semester.total_percentage }}</td>
            </tr>
            <tr>
              <td class="static-field">SGPA (Attempts)</td>

              <td>{{semester?.semWiseCumilativeResult[0]?.sem_SGPA}} <span
                  *ngIf="semester?.semWiseCumilativeResult[0]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[0]?.sem_attempt_count}})</span>
              </td>
              <td>{{semester?.semWiseCumilativeResult[1]?.sem_SGPA}} <span
                  *ngIf="semester?.semWiseCumilativeResult[1]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[1]?.sem_attempt_count}})</span>
              </td>
              <td>{{semester?.semWiseCumilativeResult[2]?.sem_SGPA}} <span
                  *ngIf="semester?.semWiseCumilativeResult[2]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[2]?.sem_attempt_count}})</span>
              </td>
              <td>{{semester?.semWiseCumilativeResult[3]?.sem_SGPA}} <span
                  *ngIf="semester?.semWiseCumilativeResult[3]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[3]?.sem_attempt_count}})</span>
              </td>
              <td>{{semester?.semWiseCumilativeResult[4]?.sem_SGPA}} <span
                  *ngIf="semester?.semWiseCumilativeResult[4]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[4]?.sem_attempt_count}})</span>
              </td>
              <td>{{semester?.semWiseCumilativeResult[5]?.sem_SGPA}} <span
                  *ngIf="semester?.semWiseCumilativeResult[5]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[5]?.sem_attempt_count}})</span>
              </td>
              <td class="static-field">Results</td>
              <td>{{ semester.overall_result }}</td>
            </tr>

          </tbody>
        </table>
      </div>

      <div class="table-container-bridge-multi">
        <table class="bridge-course-table">
          <thead>
            <tr>
              <th colspan="4" class="static-field">Bridge Course / Audit Course Without Credits</th>
            </tr>
            <tr>
              <th class="static-field bridge-sem">Sem</th>
              <th class="static-field bridge-slno">Sl.No</th>
              <th class="static-field bridge-course-style">Course Code & Course Title</th>
              <th class="static-field">Result</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="semester?.NonCreditSemResult?.length > 0; else noData">
              <!-- <ng-container *ngFor="let semester1 of semester?.NonCreditSemResult;"> -->
              <tr *ngFor="let subject of semester?.NonCreditSemResult; let i = index">
                <td>{{ subject?.sem }}</td>
                <td>{{ i + 1 }}</td>
                <td style="text-align:left !important">{{ subject?.subject_code }} &nbsp; &nbsp;&nbsp;{{
                  subject?.subject_name }}</td>
                <td>{{ subject?.result ? (subject.result.toLowerCase() === 'p' || subject.result.toLowerCase() ===
                  'pass' ? 'PASS' : 'FAIL') : '' }}
                </td>

              </tr>
              <!-- </ng-container> -->
            </ng-container>
            <ng-template #noData>
              <tr class="no-data">
                <td colspan="4" class="static-field">No Bridge Course Result</td>
              </tr>
            </ng-template>

          </tbody>
        </table>
      </div>
      <div class="signature-principal">
        <span class="static-field">Principal</span>
      </div>
      <div class="footer-disclaimer static-field">
        <p><strong>Disclaimer:</strong> The information provided in this marks card is for reference only. The final
          confirmation should be obtained from the official records.</p>
      </div>
    </div>
  </div>
  <br /> <br />
  </div>
</div>
</div>

   <div class="pagination-controls mt-3 text-center" *ngIf="getExamResultData.length > pageSize">
  <button mat-stroked-button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
    Previous
  </button>

  <button
    mat-stroked-button
    *ngFor="let page of totalPages"
    [color]="page === currentPage ? 'primary' : ''"
    (click)="goToPage(page)"
    style="margin: 0 4px;"
  >
    {{ page }}
  </button>

  <button mat-stroked-button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages.length">
    Next
  </button>
</div>
</div>


<div id="singleProvisional">
  <div *ngIf="isregNumWiseGradeCard">
    <div *ngIf="getSingleExamResultData as semester">


      <div class="marks-card">
        <div class="header">
          <div class="sno">
            <span class="static-field">Sl.No. &nbsp;: &nbsp;{{semester.gradeCardNumber}}</span>
          </div>
          <div class="center">
            <div class="container static-field">
              <img src="assets/images/img/KarntakaLogo.png" alt="Logo" style="height: 40px; margin: 0 10px;"><br />

            </div>
            <h3 class="static-field">ಕರ್ನಾಟಕ ಸರ್ಕಾರ</h3>
            <h3 class="static-field">Government of Karnataka</h3>
            <h3 class="static-field">ತಾಂತ್ರಿಕ ಶಿಕ್ಷಣ ಇಲಾಖೆ, ಬೆಂಗಳೂರು.</h3>
            <h3 class="static-field">Department Of Technical Education, Bangalore.</h3>
            <h3 class="static-field">ತಾಂತ್ರಿಕ ಪರೀಕ್ಷಾ ಮಂಡಳಿ</h3>
            <h3 class="static-field">BOARD OF TECHNICAL EXAMINATIONS.</h3>
            <h3>
              <span class="static-field">B.V.V.S.POLYTECHNIC(AUTONOMOUS), BAGALKOT.</span>
              <!-- <span>:{{ semester.Exam_month }}-{{ semester.Exam_year }}</span> -->
            </h3>
            <h3>
            <span class="static-field">GRADE CARD</span>
            </h3>
          </div>
          <div class="right static-field">
            <img *ngIf="safePhotoUrl" [src]="safePhotoUrl" style="width:180px;height:180px;" alt="Student Photo" />

          </div>
        </div>

        <div class="header">
          <div class="sno">
            <span class="static-field">Sl.No. &nbsp;: &nbsp;{{semester.gradeCardNumber}}</span>
          </div>
          <div class="center">
            <h3>
          <span style="padding-right: 349px;">{{ semester.Exam_month }}-{{ semester.Exam_year }}</span>
        </h3>
          </div>
        </div>

        <div class="info-grid-single">
          <div class="info-row">
            <span class="label static-field">PROGRAMME</span>
            <span class="colon static-field">:</span>
            <span class="value-courseName">{{ semester.courseName }}</span>
          </div>
        
          <div class="info-row">
            <span class="label static-field">NAME OF THE CANDIDATE</span>
            <span class="colon static-field">:</span>
            <span class="value-studentName">{{ semester.studentName }}</span>
          </div>
        
          <div class="info-row">
            <span class="label static-field">FATHER'S NAME</span>
            <span class="colon static-field">:</span>
            <span class="value-fatherName">{{ semester.father_name }}</span>
          </div>
        
          <div class="info-row">
            <span class="label static-field">MOTHER'S NAME</span>
            <span class="colon static-field">:</span>
            <span class="value-motherName">{{ semester.studentMotherName }}</span>
          </div>
        
          <!-- ✅ Combined row at the bottom -->
          <div class="info-bottom-row">
            <div class="left-part">
              <span class="label static-field">DATE OF RESULT</span>
              <span class="colon static-field">:</span>
              <span class="value-dateOfResult">{{ semester.dateOfResult | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="right-part">
              <!-- <span class="label-register static-field">REGISTER NO</span> -->
              <span class="colon static-field"></span>
              <span class="label-register" style="font-size: 20px;">{{ semester.registerNo }}</span>
            </div>
          </div>
        </div>


        <div class="table-container">
          <table class="course-table">
            <thead>
              <tr>
                <th class="static-field col-sem" rowspan="2">SEM</th>
                <th class="static-field col-sino" rowspan="2">Sl. No</th>
                <th class="static-field col-subject" rowspan="2">Course Code & Course Title</th>
                <th class="static-field col-credit" colspan="2">Credits</th>
                <th class="static-field col-points" rowspan="2">Grade Points</th>
                <th class="static-field col-grade" rowspan="2">Letter Grade</th>
              </tr>
              <tr>
                <th class="static-field">Applied</th>
                <th class="static-field">Earned</th>
              </tr>
            </thead>
            <tbody *ngIf="resetSeparatorFlag()">

              <ng-container
                *ngIf="getSingleExamResultData.semWiseCumilativeResult?.length <= getSingleExamResultData.maxSemesterNumber; else normalDisplay">
                <ng-container *ngFor="let subject of semester.subjectDetailsList; let i = index">
                  <!-- Subject row -->
                  <tr>
                    <td class="col-sem">{{ subject.sem }}</td>
                    <td class="col-sino">{{ subject.SINO }}</td>
                    <td class="col-subject">{{ subject.subject_code }} {{ subject.subject_name }}</td>
                    <td class="col-credit-applied">{{ subject.totalCredits }}</td>
                    <td class="col-credit-earned">{{ subject.earnedCredit }}</td>
                    <td class="col-points">{{ subject.gradePoints }}</td>
                    <td class="col-grade">{{ subject.gradeAwarded }}</td>
                  </tr>
                  <!-- Dashed separator: if it's the last subject of a semester -->
                  <tr *ngIf="shouldShowSeparator(subject.sem,semester?.subjectDetailsList, i)">
                    <td></td>
                    <td></td>
                    <td class="dashed-separator">
                      <hr />
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </ng-container>

                <!-- Add empty rows if less than 15 -->
                <ng-container
                  *ngFor="let empty of getArray(semester.subjectDetailsList); let i = index; trackBy: trackByIndex">
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </ng-container>
              </ng-container>

              <!-- No data available fallback -->
              <ng-template #normalDisplay>
                <ng-container *ngFor="let subject of semester.subjectDetailsList; let i = index">
                  <tr *ngIf="shouldShowSeparator(subject.sem,semester?.subjectDetailsList, i)">
                    <td></td>
                    <td></td>
                    <td class="dashed-separator">
                      <hr />
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <!-- Subject row -->
                  <tr>
                    <td>{{ subject.sem }}</td>
                    <td>{{ subject.SINO }}</td>
                    <td style="text-align:left !important">
                      {{ subject.subject_code }} &nbsp;&nbsp; {{ subject.subject_name }}
                    </td>
                    <td>{{ subject.totalCredits }}</td>
                    <td>{{ subject.earnedCredit !== null ? subject.earnedCredit : '-' }}</td>
                    <td>{{ subject.gradePoints !== null ? subject.gradePoints : '-' }}</td>
                    <td>{{ subject.gradeAwarded || '-' }}</td>
                  </tr>
                </ng-container>
                <ng-container
                  *ngFor="let empty of getArray(semester.subjectDetailsList); let i = index; trackBy: trackByIndex">
                  <tr>
                    <td>&nbsp;</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </ng-container>

              </ng-template>
            </tbody>
          </table>
        </div>



        <div class="table-container-cgpa">
          <table class="semester-table">
            <thead>
              <tr>
                <th style="padding: 15px;" class="static-field">Semester</th>
                <th class="static-field">I</th>
                <th class="static-field">II</th>
                <th class="static-field">III</th>
                <th class="static-field">IV</th>
                <th class="static-field">V</th>
                <th class="static-field">VI</th>
                <th class="static-field">Cumulative</th>
                <th class="static-field">UpTo This Exam</th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td class="static-field">Credits Applied</td>

                <td><span> {{semester?.semWiseCumilativeResult[0]?.TotalCreditsForSem}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[1]?.TotalCreditsForSem}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[2]?.TotalCreditsForSem}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[3]?.TotalCreditsForSem}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[4]?.TotalCreditsForSem}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[5]?.TotalCreditsForSem}}</span></td>

                <td class="static-field">Credits Earned</td>
                <td>{{ semester?.cumulative_credits_earned }}</td>
              </tr>

              <tr>
                <td class="static-field">Credits Earned</td>
                <td><span> {{semester?.semWiseCumilativeResult[0]?.sem_credits_earned}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[1]?.sem_credits_earned}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[2]?.sem_credits_earned}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[3]?.sem_credits_earned}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[4]?.sem_credits_earned}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[5]?.sem_credits_earned}}</span></td>
                <td class="static-field">CGPA</td>
                <td>{{ semester.cgpa }}</td>
              </tr>
              <tr>
                <td class="static-field">Σ(Ci X Gi)Earned</td>
                <td><span> {{semester?.semWiseCumilativeResult[0]?.sem_weighted_average}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[1]?.sem_weighted_average}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[2]?.sem_weighted_average}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[3]?.sem_weighted_average}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[4]?.sem_weighted_average}}</span></td>
                <td><span> {{semester?.semWiseCumilativeResult[5]?.sem_weighted_average}}</span></td>
                <td class="static-field">%Conversion</td>
                <td>{{ semester.total_percentage }}</td>
              </tr>
              <tr>
                <td class="static-field">SGPA(Attempts)</td>

                <td>{{semester?.semWiseCumilativeResult[0]?.sem_SGPA}} <span
                    *ngIf="semester?.semWiseCumilativeResult[0]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[0]?.sem_attempt_count}})</span>
                </td>
                <td>{{semester?.semWiseCumilativeResult[1]?.sem_SGPA}} <span
                    *ngIf="semester?.semWiseCumilativeResult[1]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[1]?.sem_attempt_count}})</span>
                </td>
                <td>{{semester?.semWiseCumilativeResult[2]?.sem_SGPA}} <span
                    *ngIf="semester?.semWiseCumilativeResult[2]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[2]?.sem_attempt_count}})</span>
                </td>
                <td>{{semester?.semWiseCumilativeResult[3]?.sem_SGPA}} <span
                    *ngIf="semester?.semWiseCumilativeResult[3]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[3]?.sem_attempt_count}})</span>
                </td>
                <td>{{semester?.semWiseCumilativeResult[4]?.sem_SGPA}} <span
                    *ngIf="semester?.semWiseCumilativeResult[4]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[4]?.sem_attempt_count}})</span>
                </td>
                <td>{{semester?.semWiseCumilativeResult[5]?.sem_SGPA}} <span
                    *ngIf="semester?.semWiseCumilativeResult[5]?.sem_attempt_count > 0">({{semester?.semWiseCumilativeResult[5]?.sem_attempt_count}})</span>
                </td>
                <td class="static-field">Results</td>
                <td>{{ semester.overall_result }}</td>
              </tr>

            </tbody>
          </table>
        </div>

        <div class="table-container-single">
          <table class="bridge-course-table">
            <thead>
              <tr>
                <th class="static-field" colspan="4">Bridge Course / Audit Course Without Credits</th>
              </tr>
              <tr>
                <th class="static-field bridge-sem">Sem</th>
                <th class="static-field bridge-slno">Sl.No</th>
                <th class="static-field bridge-course-style">Course Code & Course Title</th>
                <th class="static-field">Result</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="semester?.NonCreditSemResult?.length > 0; else noData">
                <!-- <ng-container *ngFor="let semester1 of semester?.NonCreditSemResult;"> -->
                <tr *ngFor="let subject of semester?.NonCreditSemResult; let i = index">
                  <td>{{ subject?.sem }}</td>
                  <td>{{ i + 1 }}</td>
                  <td style="text-align:left !important">{{ subject?.subject_code }} &nbsp; &nbsp;&nbsp;{{
                    subject?.subject_name }}</td>
                  <td>{{ subject?.result ? (subject.result.toLowerCase() === 'p' || subject.result.toLowerCase() ===
                    'pass' ? 'PASS' : 'FAIL') : '' }}
                  </td>

                </tr>
                <!-- </ng-container> -->
              </ng-container>
              <ng-template #noData>
                <tr class="no-data">
                  <td colspan="4">No Bridge Course Result</td>
                </tr>
              </ng-template>

            </tbody>
          </table>
        </div>
        <div class="signature-principal">
          <span class="static-field">Principal</span>
        </div>
        <div class="footer-disclaimer static-field">
          <p><strong>Disclaimer:</strong> The information provided in this marks card is for reference only. The final
            confirmation should be obtained from the official records.</p>
        </div>

      </div>


    </div>
  </div>
  <br /> <br />



</div>
    
          </mat-card-content>
          </mat-card>
          </div>
          </div>
          </div>
          


  
  

